'use client';

import React from 'react';
import { Provider } from 'jotai';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ModalProvider } from '@components/common/modal/modal.context';
// import { CartProvider } from '@contexts/cart/cart.context';

function Providers({ children }: React.PropsWithChildren) {
  const queryClientRef = React.useRef<any>();
  if (!queryClientRef.current) {
    queryClientRef.current = new QueryClient();
  }

  return (
    <Provider>
      <QueryClientProvider client={queryClientRef.current}>
        <ModalProvider>
          {/* <CartProvider> */}
            {children}
          {/* </CartProvider> */}
        </ModalProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default Providers;
